export const CHILDREN = {
  nickname: 'PRODUCTS.CHILDREN.nickname',
  icon:'children'
};
